
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { createContext } from 'react';

var focusScope = /*#__PURE__*/createContext(undefined);

export { focusScope };
//# sourceMappingURL=scope.js.map
